<template lang="pug">
  v-container(
    id="order"
    class="order-container"
  )
    template(v-if="!order_list.length")
      v-card(
        class="order-card"
      )
        v-card-title
          h3.header-title Your Orders
        v-card-text
          b Your do not have any orders.
    template(v-else)
      v-card(
        class="order-card"
        v-for="(o, index) in order_list"
        :key="o.order_id"
      )
        v-card-title(
          class="order-card-header"
          :class="o.order_type == 1 ? 'blue' : o.order_type == 2 ? 'orange' : o.order_type == 3 ? 'green' : o.order_type == 4 ? 'red' : 'grey'"
        )
          b(
            v-if="o.order_type == 1"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="white"
            ) mdi-silverware-variant
            | &nbsp;Dine In Order ID {{ o.order_id }}
          b(
            v-if="o.order_type == 2"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="white"
            ) mdi-calendar-clock
            | &nbsp;Reservation Order ID {{ o.order_id }}
          b(
            v-if="o.order_type == 3"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="white"
            ) mdi-human-greeting
            | &nbsp;Pickup Order ID {{ o.order_id }}
          b(
            v-if="o.order_type == 4"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="white"
            ) mdi-truck-delivery
            | &nbsp;Delivery Order ID {{ o.order_id }}
        v-card-title
          v-icon(
            color="primary"
          ) mdi-store
          b.ml-1 {{ o.merchant_name }}
          v-icon(
            color="primary"
          ) mdi-arrow-right-bold
          span.ml-1 {{ o.store_name }}
          v-icon(
            v-if="o.table_name"
            color="primary"
          ) mdi-arrow-right-bold
          v-icon(
            v-if="o.table_name"
            color="primary"
          ) mdi-chair-school
          em.ml-1 {{ o.table_name }}
        v-card-subtitle(
          class="mt-3"
        )
          small(
            v-if="o.order_type == 1"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="red"
              small
            ) mdi-stamper
            | &nbsp;{{ o.dinein_staff }}
          small(
            v-if="o.order_type == 2"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="red"
              small
            ) mdi-clock
            | &nbsp;{{ $helpers.formatTime(o.reserve_start) }} ~ {{ $helpers.formatTime(o.reserve_end) }}
          small(
            v-if="o.order_type == 3"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="red"
              small
            ) mdi-clock
            | &nbsp;{{ $helpers.formatTime(o.pickup_settime) }}
          small(
            v-if="o.order_type == 4"
            class="ml-2 my-auto"
          ) 
            v-icon(
              color="red"
              small
            ) mdi-clock
            | &nbsp;{{ $helpers.formatTime(o.delivery_settime) }}
        v-card-text
          v-list(
            class="p-0"
            three-line
            flat
          )
            v-list-item-group(
              v-for="(s, index) in o.order_list"
              :key="s.suborder_id"
            )
              v-list-item-content
                v-list-item-title
                  v-icon(
                    color="green"
                  ) mdi-receipt
                  b(
                    class="ml-2 my-auto"
                  ) {{ s.suborder_id }}
              v-list-item(
                v-for="(i, index) in s.item_list"
                :key="i.item_id"
              )
                template(v-slot:default="{ active }")
                  v-list-item-content
                    v-list-item-title
                      b {{ i.item_name }}
                    v-list-item-subtitle(
                      v-if="i.item_variant"
                    ) {{ i.item_variant.variant_name }}
                    v-list-item-subtitle(
                      v-if="i.item_addon.length"
                      v-for="(a, idx) in i.item_addon"
                      :key="a.addon_id"
                    )
                      em - {{ a.addon_name }}
                    v-list-item-subtitle(v-if="i.item_remarks") * {{ i.item_remarks }}
                  v-list-item-action(
                    class="m-auto"
                  )
                    span RM {{ calculatePrice(i) }}
                  v-list-item-action(
                    class="mr-2 my-auto"
                  )
                    b X {{ i.item_quantity }}
              v-divider(
                class="m-0"
              )
              v-list-item
                v-list-item-content
                  v-list-item-title
                    b Grand total
                v-list-item-action(
                  class="m-auto"
                )
                  span RM {{ o.order_finalprice }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      order_list: [],
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {},
  mounted() {
    this.$store.commit("layout/setDisplayTitle", "Your Orders");
    this.getOrderList();
  },
  methods: {
    // mapList(val) {
    //   var result = new Array();
    //   var result1, result2, result3, result4;

    //   console.log(val)

    //   val.map(x => {
    //     if (result.findIndex(a => a.merchant_id == x.merchant_id) == -1)
    //       result.push({
    //         merchant_id: x.merchant_id,
    //         merchant_name: x.merchant_name,
    //         store_list: []
    //       });

    //     result1 = result.filter(a => a.merchant_id == x.merchant_id)[0];

    //     if (result1.store_list.findIndex(b => b.store_id == x.store_id) == -1)
    //       result1.store_list.push({
    //         store_id: x.store_id,
    //         store_name: x.store_name,
    //         table_list: []
    //       });

    //     result2 = result1.store_list.filter(a => a.store_id == x.store_id)[0];

    //     if (result2.table_list.findIndex(c => c.table_id == x.table_id) == -1)
    //       result2.table_list.push({
    //         table_id: x.table_id,
    //         table_name: x.table_name,
    //         item_list: []
    //       });

    //     result3 = result2.table_list.filter(a => a.table_id == x.table_id)[0];

    //     if (
    //       result3.item_list.findIndex(c => c.item_id == x.item_parentid) == -1
    //     )
    //       result3.item_list.push({
    //         item_id: x.item_parentid,
    //         item_name: x.item_name,
    //         item_variant: null,
    //         item_addon: []
    //       });

    //     result4 = result3.item_list.filter(
    //       a => a.item_id == x.item_parentid
    //     )[0];

    //     if (result4.item_id == x.item_parentid && x.item_childtype == 1)
    //       result4.item_variant = {
    //         variant_id: x.item_id,
    //         variant_name: x.variant_name
    //       };

    //     if (result4.item_id == x.item_parentid && x.item_childtype == 2)
    //       result4.item_addon.push({
    //         addon_id: x.item_id,
    //         addon_name: x.addon_name
    //       });
    //   });

    //   console.log(result)

    //   this.order_list = result;
    // },
    mapList(val) {
      if (!val.length) return;
      
      var order, list, item;

      val.map(x => {
        if (this.order_list.findIndex(a => a.order_id == x.id) == -1)
          this.order_list.push({
            order_id: x.id,
            order_type: x.order_type,
            order_remarks: x.order_remarks,
            order_finalprice: x.order_finalprice,
            merchant_id: x.merchant_id,
            merchant_name: x.merchant_name,
            store_id: x.store_id,
            store_name: x.store_name,
            table_id: x.table_id,
            table_name: x.table_name,
            dinein_staff: x.dinein_staff,
            pickup_settime: x.pickup_settime,
            delivery_settime: x.delivery_settime,
            reserve_start: x.reserve_start,
            reserve_end: x.reserve_end,
            order_list: []
          });

        order = this.order_list.filter(b => b.order_id == x.id)[0].order_list;

        if (order.findIndex(c => c.suborder_id == x.suborder_id) == -1)
          order.push({
            suborder_id: x.suborder_id,
            item_list: []
          });

        list = order.filter(d => d.suborder_id == x.suborder_id)[0].item_list;

        if (list.findIndex(c => c.item_id == x.item_parentid) == -1)
          list.push({
            menu_id: x.menu_id,
            item_id: x.item_parentid,
            item_name: x.item_name,
            item_price: x.item_oriprice,
            item_saleprice: x.item_saleprice,
            item_quantity: x.item_quantity,
            item_remarks: x.item_remarks,
            item_variant: null,
            item_addon: []
          });

        item = list.filter(a => a.item_id == x.item_parentid)[0];

        if (item.item_id == x.item_parentid && x.item_childtype == 1)
          item.item_variant = {
            variant_id: x.item_id,
            variant_name: x.variant_name,
            variant_price: x.item_oriprice,
            variant_saleprice: x.item_saleprice
          };

        if (item.item_id == x.item_parentid && x.item_childtype == 2)
          item.item_addon.push({
            addon_id: x.item_id,
            addon_name: x.addon_name,
            addon_price: x.item_oriprice,
            addon_saleprice: x.item_saleprice
          });
      });
    },
    getOrderList() {
      this.order_list = new Array();

      let url = config.getOrderUrl();

      var json = {
        params: {
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.mapList(response.body.data);
              } else {
                this.$swal(
                  this.$t("error.customer_get_order"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.customer_get_order"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.customer_get_order"),
            response.body.message,
            "error"
          );
        });
    },
    calculateOriPrice(i) {
      var total = 0;

      //normal item price
      total += parseFloat(i.item_price);

      if (i.item_variant)
        //variant price
        total += parseFloat(i.item_variant.variant_price);

      if (i.item_addon.length)
        //addon price
        i.item_addon.forEach(a => {
          total += parseFloat(a.addon_price);
        });

      return (total * i.item_quantity).toFixed(2);
    },
    calculatePrice(i) {
      var total = 0;

      //normal item price
      total +=
        parseFloat(i.item_saleprice) != 0
          ? parseFloat(i.item_saleprice)
          : parseFloat(i.item_price);

      if (i.item_variant)
        //variant price
        total +=
          parseFloat(i.item_variant.variant_saleprice) != 0
            ? parseFloat(i.item_variant.variant_saleprice)
            : parseFloat(i.item_variant.variant_price);

      if (i.item_addon.length)
        //addon price
        i.item_addon.forEach(a => {
          total +=
            parseFloat(a.addon_saleprice) != 0
              ? parseFloat(a.addon_saleprice)
              : parseFloat(a.addon_price);
        });

      return (total * i.item_quantity).toFixed(2);
    }
  }
};
</script>
